import { useUserSettings } from '../../utils/use-user-settings';
import { isFeatureEnabled } from '../../utils/feature-flags';
import PolicyDetailsDrawerOld from './policy-details-drawer-old';
import PolicyDetailsDrawer from './policy-details-drawer';

export default function PolicyDetailsDrawerPage() {
  const { features } = useUserSettings();
  const isUiEnhancementEnabled = isFeatureEnabled(
    'uiEnhancementPhase2',
    features
  );
  return isUiEnhancementEnabled ? (
    <PolicyDetailsDrawer />
  ) : (
    <PolicyDetailsDrawerOld />
  );
}
